import React from 'react';
import { useCart } from '../context/CartContext';
import { Trash2Icon, PlusIcon, MinusIcon, ShoppingBagIcon, ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Cart() {
  const {
    cart,
    removeFromCart,
    updateQuantity,
    cartTotal,
    cartCount
  } = useCart();
  if (cart.length === 0) {
    return <div className="min-h-[60vh] flex flex-col items-center justify-center px-4" data-id="element-200">
        <div className="w-20 h-20 bg-slate-50 rounded-full flex items-center justify-center mb-6 text-slate-300" data-id="element-201">
          <ShoppingBagIcon className="w-10 h-10" data-id="element-202" />
        </div>
        <h2 className="text-2xl font-black text-slate-900 mb-2 uppercase tracking-tight" data-id="element-203">
          Your cart is empty
        </h2>
        <p className="text-slate-500 mb-8" data-id="element-204">
          Looks like you haven't added any wellness essentials yet.
        </p>
        <Link to="/otc-products" className="bg-clinical-blue text-white font-bold py-4 px-8 rounded-xl hover:bg-blue-700 transition-all uppercase tracking-widest text-xs flex items-center gap-2" data-id="element-205">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-206" /> Start Shopping
        </Link>
      </div>;
  }
  return <div className="bg-slate-50 min-h-screen py-12 sm:py-20" data-id="element-207">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-208">
        <h1 className="text-3xl sm:text-4xl font-black text-slate-900 mb-8 sm:mb-12 uppercase tracking-tighter" data-id="element-209">
          Your Shopping Cart
        </h1>

        <div className="grid lg:grid-cols-3 gap-8 sm:gap-12" data-id="element-210">
          <div className="lg:col-span-2 space-y-4" data-id="element-211">
            {cart.map(item => <div key={item.id} className="bg-white p-4 sm:p-6 rounded-2xl border border-slate-100 flex flex-col sm:flex-row gap-4 sm:gap-6 items-start sm:items-center" data-id="element-212">
                <div className="w-full sm:w-24 h-48 sm:h-24 rounded-xl bg-slate-50 overflow-hidden flex-shrink-0" data-id="element-213">
                  <img src={item.image} alt={item.name} className="w-full h-full object-cover" data-id="element-214" />
                </div>

                <div className="flex-grow w-full" data-id="element-215">
                  <h3 className="font-bold text-slate-900 mb-1" data-id="element-216">{item.name}</h3>
                  <p className="text-clinical-blue font-black mb-4" data-id="element-217">
                    {item.price}
                  </p>

                  <div className="flex items-center justify-between" data-id="element-218">
                    <div className="flex items-center border border-slate-200 rounded-lg overflow-hidden" data-id="element-219">
                      <button onClick={() => updateQuantity(item.id, -1)} className="p-2 hover:bg-slate-50 text-slate-500 transition-colors" data-id="element-220">
                        <MinusIcon className="w-4 h-4" data-id="element-221" />
                      </button>
                      <span className="px-4 font-bold text-slate-900 text-sm" data-id="element-222">
                        {item.quantity}
                      </span>
                      <button onClick={() => updateQuantity(item.id, 1)} className="p-2 hover:bg-slate-50 text-slate-500 transition-colors" data-id="element-223">
                        <PlusIcon className="w-4 h-4" data-id="element-224" />
                      </button>
                    </div>

                    <button onClick={() => removeFromCart(item.id)} className="text-slate-400 hover:text-red-500 transition-colors p-2" data-id="element-225">
                      <Trash2Icon className="w-5 h-5" data-id="element-226" />
                    </button>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="lg:col-span-1" data-id="element-227">
            <div className="bg-white p-6 sm:p-8 rounded-2xl border border-slate-100 lg:sticky lg:top-32" data-id="element-228">
              <h2 className="text-xl font-black text-slate-900 mb-6 uppercase tracking-tight" data-id="element-229">
                Order Summary
              </h2>

              <div className="space-y-4 mb-8" data-id="element-230">
                <div className="flex justify-between text-slate-500 text-sm" data-id="element-231">
                  <span data-id="element-232">Subtotal ({cartCount} items)</span>
                  <span data-id="element-233">${cartTotal.toFixed(2)}</span>
                </div>
                <div className="flex justify-between text-slate-500 text-sm" data-id="element-234">
                  <span data-id="element-235">Shipping</span>
                  <span className="text-green-600 font-bold uppercase text-[10px] tracking-widest" data-id="element-236">
                    Calculated at checkout
                  </span>
                </div>
                <div className="pt-4 border-t border-slate-100 flex justify-between items-end" data-id="element-237">
                  <span className="text-slate-900 font-bold" data-id="element-238">Total</span>
                  <span className="text-2xl font-black text-clinical-blue" data-id="element-239">
                    ${cartTotal.toFixed(2)}
                  </span>
                </div>
              </div>

              <button className="w-full bg-clinical-blue text-white font-bold py-5 rounded-xl hover:bg-blue-700 transition-all uppercase tracking-widest text-xs shadow-lg shadow-clinical-blue/20" data-id="element-240">
                Proceed to Checkout
              </button>

              <p className="mt-6 text-center text-[10px] text-slate-400 uppercase tracking-widest font-bold" data-id="element-241">
                Secure SSL Encrypted Checkout
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}